import React, { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import DropdownBox from '../../../ui/DropdownBox/DropdownBox'
import Icon from '../../../ui/Icon/Icon'
import { usePopUp } from '../../../hooks/usePopUp'
import styles from './BlogEditor.module.scss'

const LEVEL_OPTIONS = [
  { value: 2, label: 'H2' },
  { value: 3, label: 'H3' },
  { value: 4, label: 'H4' },
]

function HeadingLevelSelect({ value = 2, onChange }) {
  const buttonRef = useRef(null)
  const menuRef = useRef(null)
  const [isOpen, setIsOpen] = usePopUp(buttonRef, menuRef, true, false)
  const [menuStyle, setMenuStyle] = useState(null)
  const level = Number(value) || 2

  const updateMenuPosition = () => {
    if (!buttonRef.current) return
    const rect = buttonRef.current.getBoundingClientRect()
    setMenuStyle({
      position: 'fixed',
      top: `${rect.bottom + 4}px`,
      left: `${rect.left}px`,
      width: 'max-content',
      minWidth: '72px',
      paddingTop: 0,
      right: 'auto',
      zIndex: 9999,
    })
  }

  useEffect(() => {
    if (!isOpen) {
      setMenuStyle(null)
      return undefined
    }
    updateMenuPosition()
    const handleReposition = () => updateMenuPosition()
    window.addEventListener('resize', handleReposition)
    window.addEventListener('scroll', handleReposition, true)
    return () => {
      window.removeEventListener('resize', handleReposition)
      window.removeEventListener('scroll', handleReposition, true)
    }
  }, [isOpen])

  const menu =
    isOpen && menuStyle ? (
      <DropdownBox ref={menuRef} className={styles.headingLevelMenu} styles={menuStyle}>
        {LEVEL_OPTIONS.map((option) => {
          const active = option.value === level
          return (
            <button
              key={option.value}
              type="button"
              role="option"
              aria-selected={active}
              className={`DropdownBox-Element ${active ? styles.headingLevelOptionActive : ''}`.trim()}
              onClick={(event) => {
                event.stopPropagation()
                onChange(option.value)
                setIsOpen(false)
              }}
            >
              {option.label}
            </button>
          )
        })}
      </DropdownBox>
    ) : null

  return (
    <div
      className={styles.headingLevelWrap}
      onClick={(event) => event.stopPropagation()}
      onMouseDown={(event) => event.stopPropagation()}
    >
      <button
        ref={buttonRef}
        type="button"
        className={`${styles.headingLevelChip} ${isOpen ? styles.headingLevelChipOpen : ''}`.trim()}
        title="Рівень заголовка"
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        onClick={(event) => {
          event.stopPropagation()
          setIsOpen(!isOpen)
        }}
      >
        <span className={styles.headingLevelChipLabel}>H{level}</span>
        <Icon name="angle-down" size={10} className={styles.headingLevelChipIcon} />
      </button>
      {menu ? createPortal(menu, document.body) : null}
    </div>
  )
}

export default HeadingLevelSelect
